import { render, staticRenderFns } from "./NavigationTree.vue?vue&type=template&id=4b2e1cd4&scoped=true&"
import script from "./NavigationTree.vue?vue&type=script&lang=js&"
export * from "./NavigationTree.vue?vue&type=script&lang=js&"
import style0 from "./NavigationTree.vue?vue&type=style&index=0&id=4b2e1cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e1cd4",
  null
  
)

export default component.exports